export class TradeStatisticPreload {
  exchanges: Array<string>;
  currencies: Array<string>;
}
